import script from "./Race2024.vue?vue&type=script&setup=true&lang=js"
export * from "./Race2024.vue?vue&type=script&setup=true&lang=js"

import "./Race2024.vue?vue&type=style&index=0&id=3931bbba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3931bbba"]])

export default __exports__